import { styled } from '@mui/material/styles';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';

export const StyledMenuItem = styled(MenuItem)({
  color: 'rgba(0,0,0, 0.6)',
  paddingLeft: '12px',
  height: '48px',
});
